import { render, staticRenderFns } from "./DegreesCrud.vue?vue&type=template&id=f8d85f4a&scoped=true"
import script from "./DegreesCrud.vue?vue&type=script&lang=js"
export * from "./DegreesCrud.vue?vue&type=script&lang=js"
import style0 from "./DegreesCrud.vue?vue&type=style&index=0&id=f8d85f4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d85f4a",
  null
  
)

export default component.exports